// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__qQ_SV","buttons":"RemoveExpirationActionButtons_buttons__3dMbN"};